import styles from './OfferTextInfo.module.scss';

interface Props {
  title: string;
  desc: string;
}

const OfferTextInfo = ({ title, desc }: Props) => {
  return (
    <div className={styles.textInfoWrapper}>
      <p className={styles.textInfoTitle}>{title}</p>
      <p className={styles.textInfoDesc}>{desc}</p>
    </div>
  );
};

export default OfferTextInfo;
